import type { Consent } from '$lib/types/consent'
import { utils } from '@bruce/utils'
import { initTracking } from './tracking/init'
import { COOKIE_CONSENT_NAME } from '$lib/constants/cookie'

export function setCookieConsent(consent: Consent) {
  document.cookie = `${COOKIE_CONSENT_NAME}=${consent}; expires=${new Date(new Date().setFullYear(new Date().getFullYear() + 1))}; path=/${window.location.hostname !== 'localhost' ? `; domain=.${utils.getTldFromUrl(new URL(window.location.href))}` : ''}`

  if (consent === 'accept') {
    initTracking()
  }
}
